// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{box-sizing:border-box;margin:0;padding:0}:before :after{box-sizing:inherit}.app-container,body,html{height:100%;box-sizing:border-box}.app-container{position:relative;overflow:auto}", ""]);
// Exports
module.exports = exports;
